<template>
  <section class="employers-lt-video">
    <iframe v-if="show"
            :src="url"
            frameborder="0"
            allow="accelerometer; autoplay;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            class="employers-lt-video__video"></iframe>
    <div v-else
         class="employers-lt-video__placeholder">
      <picture class="employers-lt-video__placeholder-img-wrap">
        <source v-if="section.background_image_mob_webp"
                :srcset="section.background_image_mob_webp"
                type="image/webp"
                :media="`(max-width: ${WINDOW_SIZE_LG}px)`">
        <source v-if="section.background_image_webp"
                :srcset="section.background_image_webp"
                :media="`(max-width: ${WINDOW_SIZE_LG}px)`">

        <source :srcset="section.background_image_webp"
                type="image/webp">
        <img :src="section.background_image"
             :title="createTitleMixin(section.title)"
             :alt="createAltMixin(section.title)">
      </picture>

      <div :style="bgStyle"
           class="employers-lt-video__placeholder-gradient-bg"></div>
      <PlayButton @click.prevent="show = true"
                  class="employers-lt-video__placeholder-play"/>
      <div :style="{color: section.font_color}"
           class="employers-lt-video__placeholder-title">{{ section.title }}
      </div>
    </div>
  </section>
</template>

<script>
  import PlayButton from "@/components/PlayButton"
  import {WINDOW_SIZE_LG} from "@/constants/windowSizes"
  import hexToRgba from "hex-to-rgba"

  export default {
    name: 'EmployersLTPageVideo',
    props: {
      section: Object
    },
    components: {
      PlayButton
    },
    data() {
      return {
        show: false,
        WINDOW_SIZE_LG
      }
    },
    computed: {
      url() {
        const url = new URL(this.section.youtube)

        // https://www.youtube-nocookie.com/embed/dTfD2ZV_q1Q?
        // autoplay=1
        // modestbranding=1
        // showinfo=0
        // rel=0
        // iv_load_policy=3
        // theme=light
        // fs=0

        url.searchParams.set('autoplay', '1')
        url.searchParams.set('modestbranding', '1')
        url.searchParams.set('showinfo', '0')
        url.searchParams.set('rel', '0')
        url.searchParams.set('iv_load_policy', '3')
        url.searchParams.set('theme', 'light')
        url.searchParams.set('fs', '0')

        // url.searchParams.set('autoplay', '1')
        // url.searchParams.set('mute', '0')
        // url.searchParams.set('controls', '0')
        // url.searchParams.set('listType', 'playlist')
        // url.searchParams.set('rel', '0')

        return url.href
      },
      bgStyle() {
        const color = this.section.gradient_color

        if (color) {
          const withAlpha = hexToRgba(color, 0)
          return {
            backgroundImage: `linear-gradient(0deg, ${color} 0%, ${withAlpha} 88.54%)`
          }
        }

        return null
      }
    }
  }
</script>

<style lang="less">

</style>
